module.exports = __webpack_public_path__ + "static/img/telegram-modal-guide-btn.68dbb47.png";